<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="主题"
                      v-model="listQuery.entity.live.theme">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户编号"
                      v-model="listQuery.entity.live.userCode">
            </el-input>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.live.starts"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间开始日期"
                    end-placeholder="开始时间结束日期">
            </el-date-picker>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.live.ends"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="结束时间开始日期"
                    end-placeholder="结束时间结束日期">
            </el-date-picker>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <el-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.live.id}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="主题">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{scope.row.live.theme}}</span>
                </template>
            </el-table-column>
           <!-- <el-table-column style="font-size: 1px" align="center" label="推流地址">
                <template slot-scope="scope">
                    <span id="link" v-if="scope.row.live">{{scope.row.live.push}}</span>
                </template>
            </el-table-column>-->
            <el-table-column  align="center" label="拉流地址">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{scope.row.live.pull}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="回放地址">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{scope.row.live.back}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="streamName名称">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{scope.row.live.streamName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="用户编号">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{scope.row.live.userCode}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="开始时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{parseTime(scope.row.live.start)}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="结束时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.live">{{parseTime(scope.row.live.end)}}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                    <el-button style="margin-top: 5px" type="info" size="mini" id="btn" @click="copyLink" data-clipboard-action="copy" :data-clipboard-text="list[scope.$index].live.push">获取推流地址
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="主题" prop="live.theme">
                    <el-input v-model="temp.live.theme"></el-input>
                </el-form-item>
                <el-form-item  v-if="dialogStatus=='update'" label="推流地址" prop="live.push">
                    <el-input disabled v-model="temp.live.push"></el-input>
                </el-form-item>
                <el-form-item  v-if="dialogStatus=='update'" label="拉流地址" prop="live.pull">
                    <el-input disabled v-model="temp.live.pull"></el-input>
                </el-form-item>
                <el-form-item v-if="dialogStatus=='update'" label="回放地址" prop="live.back">
                    <el-input v-model="temp.live.back"></el-input>
                </el-form-item>
                <el-form-item label="streamName名称" prop="live.streamName">
                    <el-input placeholder="请填写2-10个英文字符" v-model="temp.live.streamName"></el-input>
                </el-form-item>
                <el-form-item label="绑定产品" >
                    <el-select  v-model="goodsList[0]"  placeholder="请选择">
                        <el-option
                                v-for="item in goodsArray"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户编号" prop="live.userCode">
                    <el-input v-model="temp.live.userCode"></el-input>
                </el-form-item>
                <el-form-item label="直播摄像头" prop="live.camera">
                    <el-select  v-model="temp.live.camera"  placeholder="请选择">
                        <el-option
                                v-for="(item,index) in cameraList"
                                :key="index"
                                :label="item"
                                :value="index"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" prop="live.start">
                    <el-date-picker v-model="temp.live.start" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="live.end">
                    <el-date-picker v-model="temp.live.end" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="封面" prop="live.img">
                    <el-upload
                            ref="imgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="imgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(imgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(imgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, down, info, save, update, remove} from '@/api/live'
    import waves from '@/directive/waves' // 水波纹指令
    import {parseTime} from '@/utils'

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'
    import Clipboard from 'clipboard'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                goodsList:[],
                cameraList:["前置","后置"],
                goodsArray:[],
                props: {multiple: true, label: "name", value: "id"},
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                start: null
                ,
                end: null
                ,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'live.id desc',
                    entity: {
                        live:
                            {
                                id: null,
                                theme: null,
                                img: null,
                                push: null,
                                pull: null,
                                back: null,
                                streamName: null,
                                start: null,
                                end: null,
                                userId: null,
                                userCode:null
                            }
                    }
                },
                temp: {

                    live:
                        {
                            id: null,
                            theme: null,
                            img: null,
                            push: null,
                            pull: null,
                            back: null,
                            streamName: null,
                            start: null,
                            end: null,
                            userId: null,
                            camera: null,
                            userCode:null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                imgList: [],
                rules:
                    {
                        'live.theme': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.img': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.push': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.pull': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.back': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.streamName': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }

                        ]
                        ,
                        'live.camera': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.start': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.end': [
                            {
                                required: true,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'live.userCode': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'live:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'live:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'live:update')
            },
            canList() {
                return hasAuth(this.perms, 'live:list')
            }
        },
        methods: {
            // 复制链接方法
            copyLink () {
                let clipboard = new Clipboard('#btn')
                clipboard.on('success', e => {
                    this.$message({
                        type: "success",
                        message: "复制成功",
                        duration: 500,
                        showClose: true,
                    });
                    clipboard.destroy() // 使用destroy可以清楚缓存
                })
                clipboard.on('error', e => {
                    this.$message({
                        type: "error",
                        message: "复制失败",
                        duration: 500,
                        showClose: true,
                    });
                    clipboard.destroy()
                })
            },
            parseTime(time) {
                if (!time) return ''
                return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.goodsArray = response.extra.goods
                    this.listLoading = false
                })
            },
            getOptions() {
                options().then(res => {
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {
                this.goodsList=[]
                this.temp = {
                    live: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.imgList = strsToList(this.temp.live.img, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.imgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.live.img = listToStrs(this.imgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp.live,this.goodsList).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.live.id]
                const ids = [this.list[this.index].live.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.live.id).then(res => {
                    this.temp = res.data
                    this.goodsList = res.extra.goods
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp.live,this.goodsList).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.goodsList =[]
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
